import { useContext, useEffect, useState, type ReactNode } from "react";

import * as Sentry from "@sentry/react";
import { useQuery } from "@tanstack/react-query";
import { getUser } from "services/User.services";

import type { User } from "types/User.type";

import { AuthTokenContext } from "components/AuthProvider/AuthProviderContext";

import { UserContext } from "./UserContext";

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const token = useContext(AuthTokenContext);

  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const { data, isLoading: queryLoading } = useQuery({
    queryKey: ["user"],
    queryFn: getUser,
    enabled: !!token,
  });

  useEffect(() => {
    const resolved = data ?? null;
    setUser(resolved);
    if (resolved) {
      Sentry.setUser({ email: resolved.email, username: `${resolved.firstName} ${resolved.lastName}` });
    } else {
      Sentry.setUser(null);
    }
  }, [data]);

  useEffect(() => {
    setIsLoading(queryLoading);
  }, [queryLoading]);

  return <UserContext.Provider value={{ user, isLoading, setUser }}>{children}</UserContext.Provider>;
};
